import VulnerabilityDisclosure from "./VulnerabilityDisclosure";

export { Page }

function Page() {
  return <VulnerabilityDisclosure />;
}